import DOMPurify from 'dompurify'

export const htmlStringSanitizer = (data?: string | null) => {
  if (!data) return ''

  const ALLOWED_TAGS = [
    'p',
    'h1',
    'h2',
    'h3',
    'br',
    'strong',
    'em',
    'i',
    'u',
    'ol',
    'ul',
    'li',
    'a',
  ]
  const ALLOWED_ATTRIBUTES = ['style', 'href', 'rel', 'target']

  const opts = {
    ALLOWED_ATTRIBUTES,
    ALLOWED_TAGS,
  }

  const sanitized = DOMPurify.sanitize(data, opts)
  const removeEmptyParagraphs = sanitized.replace(
    /<p><br><\/p>|<h1><br><\/h1>|<h2><br><\/h2>|<h3><br><\/h3>/gi,
    '<br>'
  )

  return removeEmptyParagraphs
}
